module.exports = __webpack_public_path__ + "img/8X5.b0f0de3a.png";